export enum StatusEnum {
  Created = 0,
  Live = 1,
  Stopped = 2,
  Starting = 3,
  Ready = 4,
}

export type Status =
  | StatusEnum.Created
  | StatusEnum.Live
  | StatusEnum.Stopped
  | StatusEnum.Starting
  | StatusEnum.Ready;
